import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'
import { List } from 'immutable'
import {
  DROP_PAYMENT_PROFILES,
  PAYMENT_PROFILES_SET,
  PAYMENT_PROFILES_SET_FILTER,
  PAYMENT_PROFILES_SET_LOADING,
} from 'modules/Finance/PaymentProfiles/types'

const initialState = {
  loading: true,
  loaded: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setUserPaymentProfiles = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: List(state.data).concat(List(payload.data)).toJS(),
    loading: false,
    loaded: true,
  })

const setPaymentProfilesFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
      (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
    )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropPaymentProfilesList = (state) =>
  updateObject(state, {
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_PROFILES_SET_LOADING:
      return setLoading(state, action)
    case PAYMENT_PROFILES_SET:
      return setUserPaymentProfiles(state, action)
    case PAYMENT_PROFILES_SET_FILTER:
      return setPaymentProfilesFilter(state, action)
    case DROP_PAYMENT_PROFILES:
      return dropPaymentProfilesList(state, action)
    default:
      return state
  }
}

export default reducer
